import { ReportParameters } from "./reportParameters";

export class SaveReport{

    reportName:string;
    reportCriteria:ReportParameters[];

}


// WEBPACK FOOTER //
// ./src/app/modules/reports/custom-reports/entities/saveReport.ts